import React from "react";
import styled, { keyframes } from "styled-components";
import { useTheme } from "../theme/ThemeProvider";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const HeaderContainer = styled.header`
  padding: 4em 2em;
  text-align: center;
  background: ${({ theme }) => theme.surface};
  position: relative;
  animation: ${fadeIn} 1s ease-out;

  @media (max-width: 768px) {
    padding: 2em 1em;
  }
`;

const AvatarLink = styled.a`
  display: block;
  margin: 0 auto 1.5em;
  width: 10em;
  height: 10em;
  border-radius: 50%;
  overflow: hidden;
  transition: transform ${({ theme }) => theme.animation.transition};

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 480px) {
    width: 8em;
    height: 8em;
  }
`;

const AvatarImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: filter ${({ theme }) => theme.animation.transition};

  ${({ theme }) =>
    theme.isDark &&
    `
    filter: brightness(0.9);
  `}
`;

const Title = styled.h1`
  margin-bottom: 1em;
  font-weight: bold;
  color: ${({ theme }) => theme.text.primary};
  font-size: 2.5rem;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Description = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  color: ${({ theme }) => theme.text.secondary};
  max-width: 800px;
  margin: 0 auto;
  opacity: 0;
  animation: ${fadeIn} 1s ease-out 0.5s forwards;

  @media (max-width: 768px) {
    font-size: 1.1rem;
    padding: 0 1rem;
  }
`;

const ThemeToggle = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: transparent;
  border: 2px solid ${({ theme }) => theme.text.secondary};
  color: ${({ theme }) => theme.text.secondary};
  padding: 0.5rem 1rem;
  border-radius: 20px;
  cursor: pointer;
  transition: all ${({ theme }) => theme.animation.transition};

  &:hover {
    background: ${({ theme }) => theme.text.secondary};
    color: ${({ theme }) => theme.background};
  }
`;

const Header = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <HeaderContainer>
      <ThemeToggle onClick={toggleTheme}>
        {isDark ? "☀️ Light" : "🌙 Dark"}
      </ThemeToggle>
      <AvatarLink href="#">
        <AvatarImage src="/images/me2.jpg" alt="Mohamed Sanaany" />
      </AvatarLink>
      <Title>Mohamed Sanaany</Title>
      <Description>
        Software Engineer fueled by curiosity and a passion for tackling complex
        challenges. I enjoy diving into new technologies and applying my skills
        to create robust and meaningful applications.
      </Description>
    </HeaderContainer>
  );
};

export default Header;
